import Rendering18 from "@/assets/images/3D/1.png";
import Rendering17 from "@/assets/images/3D/2.jpg";
import Rendering16 from "@/assets/images/3D/3.jpg";
import Rendering15 from "@/assets/images/3D/4.jpg";
import Rendering5 from "@/assets/images/3D/5.jpg";
import Rendering6 from "@/assets/images/3D/6.png";
import Rendering1 from "@/assets/images/3D/7.png";
import Rendering8 from "@/assets/images/3D/8.png";
import Rendering9 from "@/assets/images/3D/9.png";
import Rendering10 from "@/assets/images/3D/10.png";
import Rendering11 from "@/assets/images/3D/11.png";
import Rendering12 from "@/assets/images/3D/12.png";
import Rendering13 from "@/assets/images/3D/13.png";
import Rendering7 from "@/assets/images/3D/3d15.png";
import Rendering2 from "@/assets/images/3D/3d16.png";
import Rendering3 from "@/assets/images/3D/3d17.png";
import Rendering4 from "@/assets/images/3D/3d18.png";
import FlooPlan1 from "@/assets/images/floorplan/1.png";
import FlooPlan2 from "@/assets/images/floorplan/2.png";
import FlooPlan3 from "@/assets/images/floorplan/3.png";
import FlooPlan4 from "@/assets/images/floorplan/4.png";
import FlooPlan5 from "@/assets/images/floorplan/5.png";
import FlooPlan6 from "@/assets/images/floorplan/6.png";
import FlooPlan7 from "@/assets/images/floorplan/7.png";
import FlooPlan8 from "@/assets/images/floorplan/8.png";
import FlooPlan9 from "@/assets/images/floorplan/9.png";
import FlooPlan10 from "@/assets/images/floorplan/10.png";
import Lighting1 from "@/assets/images/lighting/1.png";
import Lighting2 from "@/assets/images/lighting/2.png";
import Lighting3 from "@/assets/images/lighting/3.png";
import Lighting4 from "@/assets/images/lighting/4.png";
import Lighting5 from "@/assets/images/lighting/5.png";
import Lighting6 from "@/assets/images/lighting/6.png";
import Lighting7 from "@/assets/images/lighting/7.png";
import LineDiagram1 from "@/assets/images/linediagram/1.png";
import LineDiagram2 from "@/assets/images/linediagram/2.png";
import Wifi1 from "@/assets/images/wifi/1.png";
import Wifi2 from "@/assets/images/wifi/2.png";
import Wifi3 from "@/assets/images/wifi/3.png";

import Project1Image from "@/assets/images/1-1Remodel.png";
import Project2Image from "@/assets/images/2Landscape Lighting.png";

import SystemDesign1 from "@/assets/images/system_design.png";
import takeoffproject1 from "@/assets/pdfs/project1.pdf";
import takeoffproject1thumb from "@/assets/pdfs/project1.png";

// ─── Types ────────────────────────────────────────────────────────────────────
export type ProjectType = "image" | "pdf" | "video" | "rendering360";

export interface BaseProject {
  id: number;
  category: string;
  type: ProjectType;
  disclaimer?: {
    label: string;
    description: string;
  };
}
export interface ImageProject extends BaseProject {
  type: "image";
  image: string;
}
export interface PdfProject extends BaseProject {
  type: "pdf";
  thumbnail: string;
  pdfUrl: string;
  title: string;
}
export interface VideoProject extends BaseProject {
  type: "video";
  thumbnail: string;
  videoUrl: string;
  title: string;
}
export interface Rendering360Project extends BaseProject {
  type: "rendering360";
  image: string; // card background
  title: string;
  views: {
    south: string;
    north: string;
    west: string;
    east: string;
  };
}
export type Project = ImageProject | PdfProject | VideoProject | Rendering360Project;

export type ViewDirection = "south" | "north" | "west" | "east";

export const draftingCategories = [
  "All",
  "Lighting Design & Analysis",
  "Wifi-Lighting Design",
  "3D Visualization & Renderings",
  "Floor Plans",
  "Line Diagrams",
];

export const takeoffCategories = [
  "All",
  "Material Takeoff",
  "Labor Estimation",
  "System Design",
];

export const draftingProjects: Project[] = [
  { id: 1, category: "3D Visualization & Renderings", type: "image", image: Rendering7, disclaimer: { label: "For Reference", description: "This rendering is for illustrative purposes only. Final output may differ based on project specifications and client requirements." } },
  { id: 2, category: "Floor Plans", type: "image", image: FlooPlan4 },
  { id: 3, category: "Lighting Design & Analysis", type: "image", image: Lighting3, disclaimer: { label: "Sample Work", description: "This is a sample lighting analysis. Actual analysis values depend on site-specific conditions, fixture selection, and project scope." } },
  { id: 4, category: "Wifi-Lighting Design", type: "image", image: Wifi1, disclaimer: { label: "Indicative", description: "Wi-Fi coverage shown is indicative. Actual performance depends on hardware, building materials, and environmental factors." } },
  { id: 5, category: "3D Visualization & Renderings", type: "image", image: Rendering11 },
  { id: 6, category: "Line Diagrams", type: "image", image: LineDiagram1 },
  { id: 7, category: "Floor Plans", type: "image", image: FlooPlan2 },
  { id: 8, category: "Lighting Design & Analysis", type: "image", image: Lighting6, disclaimer: { label: "Sample Work", description: "This is a sample lighting analysis. Actual analysis values depend on site-specific conditions, fixture selection, and project scope." } },
  { id: 9, category: "Lighting Design & Analysis", type: "image", image: Project1Image },
  { id: 10, category: "3D Visualization & Renderings", type: "image", image: Rendering3, disclaimer: { label: "For Reference", description: "This rendering is for illustrative purposes only. Final output may differ based on project specifications and client requirements." } },
  { id: 11, category: "Floor Plans", type: "image", image: FlooPlan7 },
  { id: 12, category: "Lighting Design & Analysis", type: "image", image: Lighting4 },
  { id: 13, category: "3D Visualization & Renderings", type: "image", image: Rendering1 },
  { id: 14, category: "Floor Plans", type: "image", image: FlooPlan5 },
  { id: 15, category: "Lighting Design & Analysis", type: "image", image: Lighting5 },
  { id: 16, category: "Floor Plans", type: "image", image: FlooPlan9 },
  { id: 17, category: "Wifi-Lighting Design", type: "image", image: Wifi3 },
  { id: 18, category: "3D Visualization & Renderings", type: "image", image: Rendering10 },
  { id: 19, category: "Lighting Design & Analysis", type: "image", image: Project2Image },
  { id: 20, category: "Floor Plans", type: "image", image: FlooPlan6 },
  { id: 21, category: "Line Diagrams", type: "image", image: LineDiagram2 },
  { id: 22, category: "3D Visualization & Renderings", type: "image", image: Rendering5 },
  { id: 23, category: "Lighting Design & Analysis", type: "image", image: Lighting1 },
  { id: 24, category: "3D Visualization & Renderings", type: "image", image: Rendering12 },
  { id: 25, category: "Floor Plans", type: "image", image: FlooPlan1 },
  { id: 26, category: "3D Visualization & Renderings", type: "image", image: Rendering13 },
  { id: 27, category: "Lighting Design & Analysis", type: "image", image: Lighting7 },
  { id: 28, category: "3D Visualization & Renderings", type: "image", image: Rendering6 },
  { id: 29, category: "3D Visualization & Renderings", type: "image", image: Rendering2 },
  { id: 30, category: "3D Visualization & Renderings", type: "image", image: Rendering4 },
  { id: 31, category: "Floor Plans", type: "image", image: FlooPlan10 },
  { id: 32, category: "Wifi-Lighting Design", type: "image", image: Wifi2 },
  { id: 33, category: "Lighting Design & Analysis", type: "image", image: Lighting2 },
  { id: 34, category: "3D Visualization & Renderings", type: "image", image: Rendering9 },
  { id: 35, category: "3D Visualization & Renderings", type: "image", image: Rendering8 },
  { id: 36, category: "Floor Plans", type: "image", image: FlooPlan3 },
  { id: 37, category: "Floor Plans", type: "image", image: FlooPlan8 },
  { id: 38, category: "3D Visualization & Renderings", type: "image", image: Rendering11 },
  { id: 39, category: "3D Visualization & Renderings", type: "image", image: Rendering15 },
  { id: 40, category: "3D Visualization & Renderings", type: "image", image: Rendering16 },
  { id: 41, category: "3D Visualization & Renderings", type: "image", image: Rendering17 },
  { id: 42, category: "3D Visualization & Renderings", type: "image", image: Rendering18 },
  // PDF samples
  { id: 43, category: "Floor Plans", type: "pdf", title: "Floor Plan – Sample Project", thumbnail: FlooPlan1, pdfUrl: takeoffproject1 },
  { id: 44, category: "Lighting Design & Analysis", type: "pdf", title: "Lighting Analysis Report", thumbnail: takeoffproject1thumb, pdfUrl: takeoffproject1 },
  // Video samples
  // { id: 47, category: "3D Visualization & Renderings", type: "video", title: "3D Walkthrough – Residential Project", thumbnail: Rendering7, videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4" },
  // { id: 48, category: "Floor Plans", type: "video", title: "Floor Plan Walkthrough", thumbnail: FlooPlan1, videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4" },
  // 360° samples
  { id: 45, category: "3D Visualization & Renderings", type: "rendering360", title: "Residential Project – 360° Views", image: Rendering7, views: { south: Rendering7, north: Rendering2, west: Rendering3, east: Rendering4 } },
  { id: 46, category: "3D Visualization & Renderings", type: "rendering360", title: "Commercial Build – 360° Views", image: Rendering1, views: { south: Rendering1, north: Rendering8, west: Rendering9, east: Rendering10 } },
];

export const takeoffProjects: Project[] = [
  { id: 105, category: "System Design", type: "image", image: SystemDesign1 },
  { id: 106, category: "Material Takeoff", type: "pdf", title: "Material Takeoff Report", thumbnail: takeoffproject1thumb, pdfUrl: takeoffproject1 },
  { id: 112, category: "Cost Analysis", type: "pdf", title: "Cost Analysis Summary", thumbnail: takeoffproject1thumb, pdfUrl: takeoffproject1 },
  // Video sample for takeoff
  // { id: 113, category: "Labor Estimation", type: "video", title: "Takeoff Process Walkthrough", thumbnail: FlooPlan3, videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4" },
];
